module.exports = __webpack_public_path__ + "img/image_error_holder_bak.94867948.png";